import { nortadaLogger } from '../../../../../../common/logger';

import { Operation } from './interfaces';
import SuccessOperation from './successOperation';
import FailureOperation from './failureOperation';
import UnknownOperation from './unknownOperation';

interface Props {
  operation: Operation;
}

const OperationDetails = ({ operation }: Props) => {
  switch (operation.status) {
    case 'success': {
      return <SuccessOperation operation={operation} />;
    }
    case 'failure': {
      return <FailureOperation operation={operation} />;
    }
    case 'unknown': {
      return <UnknownOperation operation={operation} />;
    }
    default: {
      nortadaLogger.critical(
        `Error in CUSTOMER_VALIDATION > Billing > Operation details.
        ${operation.status} is not supported operation status.
        Should be success, failure or unknown.`
      );
      return null;
    }
  }
};

export default OperationDetails;
